//components
import Page from 'src/components/Page'
import HeaderBreadcrumbs from 'src/components/HeaderBreadcrumbs'
import { QuillEditor } from 'src/components/editor'
import moreVerticalFill from '@iconify/icons-eva/more-vertical-fill'
import trash2Outline from '@iconify/icons-eva/trash-2-outline'
import lockOpenFill from '@iconify/icons-ph/lock-open-fill'
import editFill from '@iconify/icons-eva/edit-fill'
import AddTicketStatus from 'src/components/_dashboard/user/AddTicketStatus.js'
//materail
import { makeStyles, useTheme } from '@material-ui/core/styles'

import { experimentalStyled as styled } from '@material-ui/core/styles'
import {
  Stack,
  Avatar,
  AvatarGroup,
  Container,
  Grid,
  Card,
  Typography,
  Divider,
  Button,
  Box,
  TextField,
  Tooltip,
  Slider,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Popover,
  IconButton,
  Autocomplete,
  Menu,
  Paper,
  MenuItem,
  ListItemIcon,
  ListItemText,
  Skeleton,
} from '@material-ui/core'
import {
  AttachFile,
  Autorenew,
  Close,
  EventNote,
  Message,
  Person,
  KeyboardBackspaceOutlined,
  AddCircle,
  SendRounded,
  AddCircleOutlineRounded,
  Logout,
  Login,
  EditNotifications,
} from '@material-ui/icons'
import { LoadingButton, MobileDatePicker } from '@material-ui/lab'
import { Link as RouterLink, useLocation } from 'react-router-dom'
import { PATH_DASHBOARD } from '../../routes/paths'
import { useEffect, useRef, useState } from 'react'
import axios from 'axios'
import { REST_API_END_POINT } from 'src/constants/Defaultvalues'
import { sentenceCase, sentenceCaseTransform } from 'change-case'
import moment from 'moment'
import Icon from '@iconify/react'
import ConfirmationPopup from 'src/components/_dashboard/official-request/ConfirmationPopup'
import { useSnackbar } from 'notistack'
import Scrollbar from 'src/components/Scrollbar'
import { getAgoString, getStatusColorAndLabel, getStatusColorTicket } from 'src/common/Helper'
import { empty } from 'src/Helpers/Common'
import Label from 'src/components/Label'
import Modal from 'src/components/_dashboard/blog/ProjectModel'
import { DialogAnimate } from 'src/components/animate'
import filePdfIcon from '@iconify/icons-mdi/file-pdf';

const LabelStyle = styled(Typography)(({ theme }) => ({
  ...theme.typography.subtitle2,
  color: theme.palette.text.secondary,
  marginBottom: theme.spacing(1),
}))
const LabelStyleHead = styled(Typography)(({ theme }) => ({
  ...theme.typography.subtitle1,
  color: theme.palette.text.primary,
  marginBottom: theme.spacing(1),
}))
// const colors = [
//   '#c9302c',
//   '#5bc0de',
//   '#0275d8',
//   '#5cb85c',
//   '#f0ad4e',
//   '#c9302c',
//   '#c9302c',
//   '#5cb85c',
//   '#5bc0de',
// ]
const statusStyles = {
  1: { background: '#007bff', color: '#ffffff' }, // 🔵 New (updated)
  21: { background: '#ffc107', color: '#000000' }, // ❓ Clarification Needed
  6: { background: '#5bc0de', color: '#000000' }, // Assigned
  2: { background: '#0275d8', color: '#ffffff' }, // In Progress
  7: { background: '#f0ad4e', color: '#000000' }, // Waiting for Development
  8: { background: '#e38602', color: '#000000' }, // In Development
  9: { background: '#6c757d', color: '#ffffff' }, // Sent to QA
  10: { background: '#20c997', color: '#000000' }, // QA in Progress
  11: { background: '#d9534f', color: '#ffffff' }, // QA Failed
  12: { background: '#5cb85c', color: '#ffffff' }, // QA Passed
  14: { background: '#f7b731', color: '#000000' }, // Waiting for Client
  18: { background: '#5cb85c', color: '#000000' }, // Client approved
  20: { background: '#ff4757', color: '#ffffff' }, // Client Rejected
  15: { background: '#f39c12', color: '#000000' }, // Changes Requested
  13: { background: '#0275d8', color: '#ffffff' }, // Moved to Prod
  4: { background: '#dc3545', color: '#ffffff' }, // Re-opened
  16: { background: '#6f42c1', color: '#ffffff' }, // Escalated
  3: { background: '#28a745', color: '#ffffff' }, // Completed
  5: { background: '#c9302c', color: '#ffffff' }, // Cancelled
  17: { background: '#adb5bd', color: '#000000' }, // On Hold
  19: { background: '#212529', color: '#ffffff' }, // closed
};


const PriorColor = [
  '#f0ad4e',
  '#5bc0de',
  '#0275d8',
  '#5cb85c',
  '#f0ad4e',
  '#c9302c',
  '#c9302c',
  '#5cb85c',
  '#5bc0de',
]
const Priority = [
  { value: 'High', id: 1 },
  { value: 'Medium', id: 2 },
  { value: 'Low', id: 3 },
]

const TicketTypes = [
  { id: 1, value: 'Bug', color: '#FF4842', icon: <Stack className='ri--bug-fill' /> },
  { id: 2, value: 'Story', color: '#9C27B0', icon: <Stack className='cuida--bookmark-outline' /> },
  { id: 3, value: 'Task', color: '#54D62C', icon: <Stack className='bx--task' /> },
];

const statusFlowOrder = [
  'New',
  'Assigned',
  'In Progress',
  'Waiting for Development',
  'In Development',
  'Sent to QA for Testing',
  'QA in Progress',
  'QA Failed',
  'QA Passed',
  'Moved to Production',
  'Waiting for Client Approval',
  'Client Approved',
  'Client Rejected',
  'Changes Requested',
  'Escalated',
  'On Hold',
  'Re-opened',
  'Completed',
  'Cancelled',
  'Closed',
];
const useStyles = makeStyles((theme) => ({
  attachmentBox: {
    cursor: 'pointer',
    display: 'flex',
    borderRadius: '6px',
    backgroundColor: '#172e34',
    padding: theme.spacing(1),
    margin: theme.spacing(1, 0),
    justifyContent: 'center',
    alignItems: 'center',
    position: 'relative',
    height: '100px',
    overflow: 'hidden'
  },
  attachmentIcon: {
    marginRight: theme.spacing(1),
  },
  delete: {
    m: 2,
    display: 'flex',
    justifyContent: 'flex-end'
  },
  checkbox: {
    position: 'absolute',
    top: theme.spacing(1),
    right: theme.spacing(1),
  },
  checkboxContainer: {
    position: 'absolute',
    top: theme.spacing(1),
    right: theme.spacing(1),
  },
  dialogContent: {
    padding: theme.spacing(3),
    maxWidth: 768,
    margin: 'auto',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  gridContainer: {
    height: 'auto',
  },
}));

// const statusFlowOrder = ['New', 'In Progress', 'Completed', 'Re Open', 'Cancelled'];
export default function ViewTicketCrm({ popupOn = false, ticketId: propTicketId, closeView, onDataChange, setRefreshTickets, refreshTickets }) {
  const ref = useRef()
  const theme = useTheme()
  const [value, setValue] = useState({ id: 1, value: 'New' })
  const [valueTemp, setValueTemp] = useState({ id: 1, value: 'New' })
  const [prior, setPrior] = useState({ id: 1, value: '' })
  const { enqueueSnackbar } = useSnackbar()
  const [open, setIsOpen] = useState(false)
  const [openPop, setOpenPop] = useState(false)
  const [delPopup, setDelPopup] = useState(false)
  const [statusChangeOpen, setStatusChangeOpen] = useState(false)
  const [task, setTask] = useState(null)
  const [members, setMembers] = useState(null)
  const [taskMembers, setTaskMembers] = useState(null)
  const [objectives, setObjectives] = useState(null)
  const [selectedTeam, setSelectedteam] = useState(null)
  const [actions, setActions] = useState(null)
  const [isPosting, setIsPosting] = useState(false);
  const [postMessage, setPostMessage] = useState('')
  const [message, setMessage] = useState([])
  const location = useLocation()
  const ticketId = popupOn ? propTicketId : location.state?.id
  // const userID=location.state?.userID
  const user = localStorage.getItem('user')
  const userData = JSON.parse(user)
  const [opens, setOpens] = useState(false);
  const [files, setFiles] = useState([])
  const [isLoggedIn, setIsLoggedIn] = useState(false)
  const [elapsedTime, setElapsedTime] = useState(0)
  const [staffTimeLog, setStaffTimeLog] = useState(null)
  const [totalTime, setTotalTime] = useState("00:00:00")
  const [devDueDate, setDevDueDate] = useState('');
  const [isEditing, setIsEditing] = useState(false);
  const [startDate, setStartDate] = useState('');
  const [isEditingStartDate, setIsEditingStartDate] = useState(false);
  const pickerRef = useRef(null);
  const startDatePickerRef = useRef(null);
  const classes = useStyles();
  const [selectedPDF, setSelectedPDF] = useState(null);
  const [openPDFModal, setOpenPDFModal] = useState(false);
  const [ticketType, setTicketType] = useState({ id: 1, value: 'Bug' });
  const [pdfLoading, setPdfLoading] = useState(true);
  console.log("devDueDate==========", devDueDate);
  const handleOpens = () => {
    console.log('Avatar clicked');
    setOpens(true);
  };

  const handleCloses = () => {
    console.log('close clicked');
    setOpens(false);
  };
  const fetchTicketDetails = async () => {
    try {
      const res = await axios.post(
        `${REST_API_END_POINT}tickets/view-ticket-by-id`,
        {
          taskId: ticketId,
        },
      )
      let statusData = AddTicketStatus?.find(
        (opt) => res.data.task.status === opt.value,
      )
      let priorityVal = Priority?.find(opt => res.data.task.priority === opt.id)
      setPrior(priorityVal)
      let ticketTypeVal = TicketTypes.find(opt => opt.id === res.data.task.ticket_type) || TicketTypes[0];
      setTicketType(ticketTypeVal);
      setValue({ id: statusData.value, value: statusData.label })
      setTask(res.data.task)
      setTaskMembers(res.data.taskMembers)
      setMembers(res.data.members)
      setObjectives(res.data.objectives)
      setActions(res.data.actions)
    } catch (error) {
      console.log(error)
    }
  }

  const fetchTicketsMessages = async () => {
    try {
      axios
        .post(`${REST_API_END_POINT}tickets/get-messages`, {
          id: ticketId,
          userId: userData.user_id,
        })
        .then((res) => {
          if (res.data.status === 1) {
            setMessage(res.data.data)
          }
        })
    } catch (error) {
      console.log(error)
    }
  }


  const deleteMessage = async (messageId) => {
    try {
      const res = await axios.post(`${REST_API_END_POINT}tickets/delete-message`, {
        messageId, // Pass the message ID to the backend
        userId: userData.user_id,
      });

      if (res.data.status === 1) {
        enqueueSnackbar('Message deleted successfully', { variant: 'success' });
        fetchTicketsMessages(); // Refresh the messages
      } else {
        enqueueSnackbar('Failed to delete message', { variant: 'error' });
      }
    } catch (error) {
      console.error('Error deleting message:', error);
      enqueueSnackbar('An error occurred while deleting the message', { variant: 'error' });
    }
  };

  const fetchFileData = async () => {
    const response = await axios.post(`${REST_API_END_POINT}tickets/get-ticket-files`, { taskId: ticketId })
    if (response.data.status == 1) {
      setFiles(response.data.result)
    } else {
      setFiles([])

    }
  }


  // const viewFile = (fileUrl) => {
  //   window.open(fileUrl, "_blank");
  // };


  useEffect(() => {
    fetchTicketDetails()
    fetchTicketsMessages()
    fetchFileData()
  }, [ticketId])
  const HandleClose = () => {
    setOpenPop(false)
  }
  const fileInputRef = useRef(null)

  const handleDeleteMenu = () => {
    setDelPopup(!delPopup)
  }
  const handleGoBack = () => {
    if (popupOn && closeView) {
      closeView()
    } else {
      window.history.back()
    }
  }
  const DeleteTicket = async () => {
    try {
      let res = await axios.post(`${REST_API_END_POINT}tickets/delete-ticket`, {
        taskId: ticketId,
        userId: userData.user_id,
      })
      if (res.data.status == 1) {
        enqueueSnackbar(res.data.message, { variant: 'success' })
        if (onDataChange) {
          onDataChange()
        }
        // For deletion, trigger immediate refresh
        if (setRefreshTickets) {
          setRefreshTickets(prev => !prev)
        }
        // Close dialog after refresh is triggered
        setTimeout(() => {
          handleGoBack()
        }, 200)
      } else {
        enqueueSnackbar('failed to delete ticket', { variant: 'error' })
      }
      setDelPopup(!delPopup)
      setIsOpen(!open)
    } catch (error) {
      console.log(error, 'error in deleting ticket')
    }
  }
  const sendPostMessage = async () => {
    const cleanMessage = postMessage.replace(/<p><br><\/p>/g, '').replace(/<[^>]+>/g, '').trim();
    try {
      if (!cleanMessage) {
        enqueueSnackbar('Please write a message', { variant: 'warning' })
        return
      } else {
        setIsPosting(true);
        let res = await axios.post(
          `${REST_API_END_POINT}tickets/send-message`,
          {
            taskId: ticketId,
            message: postMessage.trim(),
            userId: userData.user_id,
          },
        )

        if (res.data.status === 1) {
          setPostMessage('')
          fetchTicketsMessages()
          if (onDataChange) {
            onDataChange()
          }
        }
      }
    } catch (error) {
      console.log(error, 'error in sending message')
    }
    finally {
      setIsPosting(false);
    }
  }
  const handleMember = (value) => {
    setSelectedteam((prevProd) => [...value])
  }
  console.log('postMessage cleared:', postMessage);
  const addMemberstoTicket = async () => {
    try {
      setIsPosting(true)

      const response = await axios.post(
        `${REST_API_END_POINT}tickets/add-members`,
        { taskId: ticketId, selectedTeam, admin_mail: userData.email, user_type: userData.user_type, task },
      )

      if (response.data.status == 1) {
        enqueueSnackbar(response.data.message, { variant: 'success' })
        setOpenPop(false)
        fetchTicketDetails()
        setIsOpen(false)
        if (onDataChange) {
          onDataChange()
        }
      } else {
        enqueueSnackbar('Failed to add the users', { variant: 'error' })
        setOpenPop(false)
      }

      setIsPosting(!isPosting)
    } catch (error) {
      console.log(error)
    } finally {
      setIsPosting(false)

    }
  }
  const handleUpdateStatus = async (status) => {
    try {
      const user = JSON.parse(window.localStorage.getItem('user'))
      const today = moment().unix()
      const res = await axios
        .post(
          `${REST_API_END_POINT}tickets/update-ticket-status`,
          { status, id: ticketId, userId: user.user_id, today },
          {
            headers: {
              'Content-Type': 'application/json',
            },
          },
        )
        .then((response) => {
          if (response.data.status === 1) {
            enqueueSnackbar('Updated', { variant: 'success' })
            fetchTicketDetails()
            if (onDataChange) {
              onDataChange()
            }
          } else if (response.data.status === 0) {
            enqueueSnackbar('Failed to Update', { variant: 'error' })
          }
        })
    } catch (error) {
      console.error('Error status update:', error)
      throw error
    }
  }
  const UpdatePriority = async (value) => {
    try {
      const user = JSON.parse(window.localStorage.getItem('user'))
      const res = await axios
        .post(
          `${REST_API_END_POINT}tickets/update-ticket-priority`,
          { priority: value.id, id: ticketId, userId: user.user_id },
          {
            headers: {
              'Content-Type': 'application/json',
            },
          },
        )
        .then((response) => {
          if (response.data.status === 1) {
            enqueueSnackbar('Updated', { variant: 'success' })
            fetchTicketDetails()
            if (onDataChange) {
              onDataChange()
            }
          } else if (response.data.status === 0) {
            enqueueSnackbar('Failed to Update', { variant: 'error' })
          }
        })
    } catch (error) {
      console.error('Error status update:', error)
      throw error
    }
  }
  const updateTicketType = async (value) => {
    try {
      const user = JSON.parse(window.localStorage.getItem('user'));
      const res = await axios.post(
        `${REST_API_END_POINT}tickets/update-ticket-type`,
        { ticket_type: value.id, id: ticketId, userId: user.user_id }
      );

      if (res.data.status === 1) {
        enqueueSnackbar('Ticket type updated', { variant: 'success' });
        fetchTicketDetails();
        if (onDataChange) {
          onDataChange()
        }
      } else {
        enqueueSnackbar('Failed to update ticket type', { variant: 'error' });
      }
    } catch (error) {
      console.error('Error updating ticket type:', error);
    }
  };

  const ActivityComponent = ({ activity }) => {
    const theme = useTheme()
    return (
      <Typography
        variant="body1"
        component="div"
        color={theme.palette.primary.darker}
        sx={{ '& strong': { fontWeight: 'bold' } }}
        dangerouslySetInnerHTML={{ __html: activity }}
      />
    )
  }

  useEffect(() => {
    fetchTimeLogData();
  }, [])
  const handleClockInOut = async () => {
    try {
      let res = ''
      const now = Math.round(moment().valueOf() / 1000)
      if (isLoggedIn) {
        const timeLogId = staffTimeLog?.id
        const startTime = staffTimeLog?.start_time
        const teamId = userData?.user_id // staffTimeLog?.staff_id
        const taskId = ticketId
        res = await axios.post(
          `${REST_API_END_POINT}tickets/update-staff-ticket-timelog`,
          {
            taskId,
            timeLogId,
            startTime,
            now,
            teamId,
          },
        )
        // setFetchData(true)

        // fetchTimeLogData();
      } else {
        console.log('isLoggedInisLoggedInisLoggedIn', isLoggedIn)
        res = await axios.post(
          `${REST_API_END_POINT}tickets/add-ticket-timelog`, {
          taskId: ticketId, userId: userData?.user_id, now: now
        }
        )
        // setFetchData(true)
      }
      setElapsedTime(0);
      if (res.data.status === 1) {
        fetchTimeLogData();
        if (res.data.result === 'add') {
          enqueueSnackbar('Clocked In successfully', { variant: 'success' })
          setIsLoggedIn(true);

        } else if (res.data.result === 'update') {
          enqueueSnackbar('Clocked Out successfully', { variant: 'success' })
          setIsLoggedIn(false);
          setTotalTime(res.data.totalTime)
        }
      } else {
        console.log('handleClockInOut res : ', res.data)
      }

    } catch (error) {
      console.log('HandleClockInOut error : ', error)
    }
  }


  const fetchTimeLogData = async () => {
    try {
      let taskId = ticketId
      const res = await axios.post(`${REST_API_END_POINT}tickets/fetch-clockedIn-staff-ticket-timelog`,
        { teamId: userData?.user_id, taskId });
      if (res.data.status === 1) {
        const staffTimeLogData = res.data.result[0];
        let taskIds = staffTimeLogData?.installation_id;
        taskIds = taskIds?.toString();
        setTotalTime(res.data.totalTime)
        setStaffTimeLog(staffTimeLogData);
        if (staffTimeLogData.end_time === null) {
          setIsLoggedIn(true);
        } else {
          setIsLoggedIn(false);
        }
      } else {
        setStaffTimeLog(null);
        setIsLoggedIn(false);
        setCheckedItems([]);
      }
    } catch (error) {
      console.log('Error fetching : ', error);
    }
  }

  useEffect(() => {
    if (staffTimeLog) {
      const interval = setInterval(() => {
        const now = Math.round(moment().valueOf() / 1000)
        const difference = now - staffTimeLog?.start_time

        setElapsedTime(difference)
      }, 1000)

      return () => clearInterval(interval)
    }
  }, [staffTimeLog])

  const hours = String(Math.floor(elapsedTime / 3600)).padStart(2, '0')
  const minutes = String(Math.floor((elapsedTime % 3600) / 60)).padStart(2, '0')
  const seconds = String(elapsedTime % 60).padStart(2, '0')

  const handleUpdateDevDueDate = async (date) => {
    try {
      const unixTimestamp = moment(date).unix()
      if (unixTimestamp) {
        const res = await axios.post(`${REST_API_END_POINT}tickets/update-dev-due-date`, {
          taskId: ticketId,
          devDueDate: unixTimestamp,
          userId: userData.user_id,
        })
        if (res.data.status === 1) {
          enqueueSnackbar('Updated', { variant: 'success' })
          setIsEditing(false);
          fetchTicketDetails()
          if (onDataChange) {
            onDataChange()
          }
        } else if (res.data.status === 0) {
          enqueueSnackbar('Failed to Update', { variant: 'error' })
        }

      }
    } catch (error) {
      console.error('Error updating dev due date:', error)
    }
  }

  const handleUpdateStartDate = async (date) => {
    try {
      const unixTimestamp = moment(date).unix()
      if (unixTimestamp) {
        const res = await axios.post(`${REST_API_END_POINT}tickets/update-start-date`, {
          taskId: ticketId,
          startDate: unixTimestamp,
          userId: userData.user_id,
        })
        if (res.data.status === 1) {
          enqueueSnackbar('Start date updated', { variant: 'success' })
          setIsEditingStartDate(false);
          fetchTicketDetails()
          if (onDataChange) {
            onDataChange()
          }
        } else if (res.data.status === 0) {
          enqueueSnackbar('Failed to update start date', { variant: 'error' })
        }
      }
    } catch (error) {
      console.error('Error updating start date:', error)
    }
  }
  useEffect(() => {
    const handleClickOutside = (event) => {
      const dialog = document.querySelector('[role="dialog"]'); // Date Picker popup container
      if (
        pickerRef.current &&
        !pickerRef.current.contains(event.target) &&
        (!dialog || !dialog.contains(event.target))
      ) {
        setIsEditing(false);
      }
      if (
        startDatePickerRef.current &&
        !startDatePickerRef.current.contains(event.target) &&
        (!dialog || !dialog.contains(event.target))
      ) {
        setIsEditingStartDate(false);
      }
    };

    if (isEditing || isEditingStartDate) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isEditing, isEditingStartDate]);

  return (
    <Container>
      <Button
          variant="outlined"
          type="button"
          onClick={() => {
            if (popupOn) {
              if (onDataChange) {
                onDataChange()
              }
              handleGoBack()
            } else {
              localStorage.setItem('refreshTickets', 'true');   // ✅ Set a flag
              window.history.back();
            }
          }}
          sx={{ alignItems: 'flex-end', mb: 4 ,mt:4 }}
          startIcon={
            <Stack>
              <KeyboardBackspaceOutlined />
            </Stack>
          }
        >
          Back to Tickets
        </Button>

        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
        >
          {/* <HeaderBreadcrumbs heading={` Ticket : ${task?.name}`} /> */}
          <HeaderBreadcrumbs heading={task?.name !== undefined ? `Ticket : ${task?.name}` : 'Ticket'} />

          <IconButton ref={ref} sx={{ backgroundColor: theme.palette.info.dark }} onClick={() => setIsOpen(!open)}>
            <Icon icon={moreVerticalFill} width={20} height={20} color='white' />
          </IconButton>
        </Stack>
        <Menu
          open={open}
          anchorEl={ref.current}
          onClose={() => setIsOpen(false)}
          PaperProps={{
            sx: { width: 200, maxWidth: '100%' },
          }}
          anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
          transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        >
          {userData.user_type === 1 && (
            <MenuItem
              onClick={() => handleDeleteMenu()}
            // sx={{ color: 'text.secondary' }}
            >
              <ListItemIcon>
                <Icon icon={trash2Outline} width={24} height={24} />
              </ListItemIcon>
              <ListItemText
                primary="Delete Ticket"
                primaryTypographyProps={{ variant: 'body2' }}
              />
            </MenuItem>
          )}

          {/* {userData.user_type === 1 && ( */}
          <MenuItem
            onClick={() => setOpenPop(true)}
          // sx={{ color: 'text.secondary' }}
          >
            <ListItemIcon>
              <AddCircleOutlineRounded />
            </ListItemIcon>
            <ListItemText
              primary="Add Support Agents"
              primaryTypographyProps={{ variant: 'body2' }}
            />
          </MenuItem>
          {/* )} */}
        </Menu>

        <Grid container justifyContent={'center'} spacing={3}>
          <Grid item xs={12} md={10}>

            <Stack spacing={3}>
              <Card sx={{ p: 3 }}>
                <Box sx={{ mb: 1, }} display={'flex'}
                  flexDirection={{ xs: 'column', md: 'row' }}
                  justifyContent="space-between">
                  {/* {userData.user_type===1 ? ( */}
                  <Stack spacing={3}>
                    <Stack
                      direction={{ xs: 'column', md: 'row' }}
                      spacing={{ xs: 2, md: 0 }}
                      alignItems="center"
                      sx={{ mb: 1, gap: 1 }}
                      justifyContent="flex-start"
                    >
                      <LabelStyleHead>Status {' '}</LabelStyleHead>
                      <TextField
                        select
                        size="small"
                        // disabled={userData.user_type==1}
                        value={value.value}
                        sx={{
                          width: '100%',
                          background: statusStyles[value.id]?.background,
                          color: statusStyles[value.id]?.color,
                          borderRadius: 1,
                          border: 'none',
                          '&:hover': {
                            // transform: 'scale(1.02)',
                            border: 'none',
                          },
                        }}
                        SelectProps={{
                          MenuProps: {
                            PaperProps: {
                              sx: {
                                maxHeight: 250, // Limit the dropdown height
                                overflowY: 'auto',
                                '&::-webkit-scrollbar': {
                                  width: '6px',
                                },
                                '&::-webkit-scrollbar-track': {
                                  background: '#f1f1f1',
                                },
                                '&::-webkit-scrollbar-thumb': {
                                  backgroundColor: '#888',
                                  borderRadius: '10px',
                                },
                                '&::-webkit-scrollbar-thumb:hover': {
                                  background: '#555',
                                },
                              },
                            },
                          },
                        }}
                      >
                        {AddTicketStatus?.map((optio) => (
                          <MenuItem
                            onClick={() => {
                              // setValue({ id: optio.value, value: optio.label })
                              setValueTemp({ id: optio.value, value: optio.label })
                              setStatusChangeOpen(true)
                            }}
                            key={optio.value}
                            value={optio.label}
                          // disabled={
                          //   statusFlowOrder.indexOf(optio.label) < statusFlowOrder.indexOf(value.value)
                          // }
                          // disabled={
                          //   value.value === 'Re-opened'
                          //     ? !['Completed', 'Cancelled'].includes(optio.label)
                          //     : statusFlowOrder.indexOf(optio.label) < statusFlowOrder.indexOf(value.value)
                          // }
                          // sx={{
                          //   background: statusStyles[optio.value]?.background,
                          //   color: statusStyles[optio.value]?.color,
                          //   '&.Mui-disabled': {
                          //     opacity: 0.5,
                          //   },
                          // }}
                          >
                            {optio.label}
                          </MenuItem>
                        ))}
                      </TextField>
                    </Stack>
                  </Stack>

                  {/* clockin */}
                  {
                    userData.user_type === 1 ?
                      ""
                      :

                      <Stack spacing={3}>
                        <Stack
                          direction={{ xs: 'column', md: 'row' }}
                          spacing={{ xs: 2, md: 0 }}
                          alignItems="center"
                          sx={{ mb: 1, gap: 1 }}
                          justifyContent="flex-start"
                        >
                          <>
                            <Card>
                              <Stack
                                justifyContent="flex-end"
                                alignItems="center"
                                flexDirection="row"

                              >
                                <Stack
                                  justifyContent="center"
                                  alignItems="center"
                                  flexDirection="column"
                                  sx={{ mr: 2 }}
                                >
                                  <Typography
                                    variant="h6"
                                    sx={{
                                      textAlign: 'center',
                                      color: theme.palette.secondary,
                                    }}
                                  >
                                    {'Date'}{' '}
                                  </Typography>
                                  <Typography
                                    variant="h5"
                                    sx={{
                                      textAlign: 'center',
                                      color: theme.palette.secondary,
                                    }}
                                  >
                                    {moment().format('MM/DD/YYYY')}
                                  </Typography>
                                </Stack>
                                <Stack
                                  justifyContent="center"
                                  alignItems="center"
                                  flexDirection="column"
                                >
                                  <Typography
                                    variant="h5"
                                    sx={{ textAlign: 'center', color: '#fc8c03' }}
                                  >
                                    {'Work Time'}{' '}
                                  </Typography>
                                  {isLoggedIn ? (
                                    // (elapsedTime!==0) ?
                                    <Typography
                                      variant="h5"
                                      sx={{
                                        textAlign: 'center',
                                        color: '#fc8c03',
                                      }}
                                    >
                                      {hours + ':' + minutes + ':' + seconds}
                                    </Typography>
                                  ) : (
                                    // :
                                    // <Stack sx={{mr:2,textAlign: 'center',mb: 2}}>
                                    //   <CircularProgress color="warning" variant="indeterminate" size='20px' />
                                    // </Stack>
                                    <Typography
                                      variant="h5"
                                      sx={{
                                        textAlign: 'center',
                                        color: '#fc8c03',
                                      }}
                                    >
                                      {'00:00:00'}
                                    </Typography>
                                  )}
                                </Stack>
                              </Stack>
                            </Card>
                            <Button
                              variant="contained"
                              type="submit"
                              onClick={() => {
                                handleClockInOut()
                              }}
                              sx={{ mb: 2, ml: 2 }}
                              startIcon={
                                <Stack>
                                  {isLoggedIn ? <Logout /> : <Login />}
                                </Stack>
                              }
                            >
                              {isLoggedIn ? 'Clock Out' : 'Clock In'}
                            </Button>
                          </>
                        </Stack>
                      </Stack>

                  }


                  {/* ):( */}
                  {/* <Label 
              variant={theme.palette.mode === 'light' ? 'ghost' : 'filled'}
              color={getStatusColorTicket(task?.status).color} >
              {getStatusColorTicket(task?.status).label}
            </Label>
            )} */}
                  <Stack direction="column" spacing={1}>
                    {userData.user_type === 1 ? (
                      <Stack spacing={3}>
                        <Stack
                          direction={{ xs: 'column', md: 'row' }}
                          spacing={{ xs: 2, md: 0 }}
                          alignItems="center"
                          sx={{ mb: 1, gap: 1 }}
                          justifyContent="flex-start"
                        >
                          <LabelStyleHead>Priority {' '}</LabelStyleHead>
                          <TextField
                            select
                            size="small"
                            value={prior.value}
                            sx={{
                              width: '70%',
                              background: PriorColor[prior.id],
                              borderRadius: 1,
                              border: 'none',
                              '&:hover': {
                                // transform: 'scale(1.02)',
                                border: 'none',
                              },
                            }}
                          >
                            {Priority?.map((optio) => (
                              <MenuItem
                                onClick={() => {
                                  setPrior(optio)
                                  UpdatePriority(optio)
                                }}
                                key={optio.value}
                                value={optio.value}
                              >
                                {optio.value}
                              </MenuItem>
                            ))}
                          </TextField>
                        </Stack>
                      </Stack>
                    ) : (
                      <Label sx={{ mt: 1 }}
                        variant={theme.palette.mode === 'light' ? 'ghost' : 'filled'}
                        color={task?.priority === 1 ? 'error' : task?.priority === 2 ? 'info' : 'success'} >
                        Priority {task?.priority === 1 ? 'High' : task?.priority === 2 ? 'Medium' : 'Low'}
                      </Label>
                    )}
                    {userData.user_type === 1 ? (
                      <Stack spacing={3}>
                        <Stack
                          direction={{ xs: 'column', md: 'row' }}
                          spacing={{ xs: 2, md: 0 }}
                          alignItems="center"
                          sx={{ mb: 1, gap: 1 }}
                          justifyContent="flex-start"
                        >
                          <LabelStyleHead sx={{ whiteSpace: 'nowrap', }}>Ticket Type</LabelStyleHead>
                          <TextField
                            select
                            size="small"
                            value={ticketType.value}
                            sx={{
                              width: '70%',
                              background: ticketType.color,
                              color: '#fff',
                              borderRadius: 1,
                              border: 'none',
                              '&:hover': {
                                border: 'none',
                              },
                            }}
                          >
                            {TicketTypes.map((typeOption) => (
                              <MenuItem
                                key={typeOption.id}
                                value={typeOption.value}
                                onClick={() => {
                                  setTicketType(typeOption);
                                  updateTicketType(typeOption);
                                }}
                              >
                                {typeOption.value}
                              </MenuItem>
                            ))}
                          </TextField>
                        </Stack>
                      </Stack>
                    ) : (
                        <Label
                          sx={{ mt: 1, backgroundColor: ticketType.color, color: 'common.white', display: 'inline-flex', gap: '3px', alignItems: 'center' }}
                          variant={theme.palette.mode === 'light' ? 'ghost' : 'filled'}
                        >
                          Ticket Type: {ticketType.icon} {ticketType.value}
                        </Label>
                    )}
                  </Stack>
                </Box>
                <Stack
                  direction={{ xs: 'column', md: 'row' }}
                  display="flex"
                  flexDirection="row"
                  justifyContent="space-between"
                >
                  {task?.project_name !== null && (
                    <Typography variant="subtitle1">
                      <span style={{ color: theme.palette.primary.darker }}>
                        Job:{' '}
                      </span>
                      {task && `${task?.project_name} (${task?.short_code})`}
                    </Typography>
                  )}
                  <Box>
                    <Tooltip title={task?.client_name}>
                      <Avatar
                        sx={{ width: 50, height: 50 }}
                        alt={task?.client_name}
                        src={task?.client_pic}
                      />
                    </Tooltip>
                  </Box>
                </Stack>

                <Stack>
                  <Typography variant="subtitle2">
                    Ticket Description
                  </Typography>
                  <Typography
                    sx={{ mb: 3, display: 'block', color: 'text.secondary' }}
                    variant="subtitle1"
                  >
                    <ActivityComponent activity={task?.description} />
                  </Typography>
                </Stack>
                <Stack
                  sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    flexDirection: 'row',
                  }}
                >
                  <Stack>
                    <Typography variant="subtitle2">
                      Ticket ID {task?.ID === undefined ? '' : 'SW-' + task?.ID}
                    </Typography>
                    <Typography variant="subtitle2" sx={{ color: "#5CB338" }}>
                      Total Work Duration : {isLoggedIn ? "calculating..." : totalTime} hrs
                    </Typography>
                  </Stack>
                  <Stack>
                    <Stack
                      flexDirection="column"
                      sx={{ justifyContent: 'flex-end' }}
                    >
                      <Typography variant="subtitle2" sx={{ color: "#5CB338" }}>
                        Created At :{task?.timestamp ?
                          moment.unix(task?.timestamp).format('MM/DD/YYYY') : ''}
                      </Typography>
                      <Typography variant="subtitle2" sx={{ color: "#FB4141" }}>
                        Due Date :{task?.due_date ?
                          moment.unix(task?.due_date).format('MM/DD/YYYY') : ''}
                      </Typography>
                      {task?.start_date && !isEditingStartDate ? (
                        <Box display="flex" alignItems="center" gap={1}>
                          <Typography variant="subtitle2" sx={{ color: "#28a745" }}>
                            Development Start Date: {moment.unix(task.start_date).format('MM/DD/YYYY')}
                          </Typography>
                          <IconButton size="small" onClick={() => setIsEditingStartDate(true)}>
                            <Stack className="hugeicons--edit-02"
                              style={{ marginRight: 8, color: '#637381' }}
                            />
                          </IconButton>
                        </Box>
                      ) : (
                        <>
                          <Typography variant="subtitle2" sx={{ color: "#28a745" }}>
                          Development Start Date:
                          </Typography>
                          <Box
                            ref={startDatePickerRef}
                            sx={{ display: 'inline-block' }}
                          >
                            <MobileDatePicker
                              value={startDate}
                              // minDate={moment()}
                              onChange={(date) => setStartDate(date)}
                              onAccept={handleUpdateStartDate}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  size="small"
                                  fullWidth
                                  sx={{
                                    width: '200px',
                                    '& .MuiInputBase-root': { height: '25px' },
                                    '.css-1mj2sml-MuiInputBase-root-MuiOutlinedInput-root.Mui-error .MuiOutlinedInput-notchedOutline': {
                                      borderColor: '#28a745',
                                    }
                                  }}
                                />
                              )}
                            />
                          </Box>
                        </>
                      )}
                      {task?.dev_due_date && !isEditing ? (
                        <Box display="flex" alignItems="center" gap={1}>
                          <Typography variant="subtitle2" sx={{ color: "#1e82e9" }}>
                            Actual development period: {moment.unix(task.dev_due_date).format('MM/DD/YYYY')}
                          </Typography>
                          <IconButton size="small" onClick={() => setIsEditing(true)}>
                            <Stack className="hugeicons--edit-02"
                              style={{ marginRight: 8, color: '#637381' }}
                            />
                            {/* <EditNotifications fontSize="small" /> */}
                          </IconButton>
                        </Box>
                      ) : (
                        <>
                          <Typography variant="subtitle2" sx={{ color: "#1e82e9" }}>
                            Actual development period:
                          </Typography>
                          <Box
                            ref={pickerRef}
                            sx={{ display: 'inline-block' }}
                          >
                            <MobileDatePicker
                              // ref={pickerRef}
                              value={devDueDate}
                              minDate={moment()}
                              onChange={(date) => setDevDueDate(date)}
                              onAccept={handleUpdateDevDueDate}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  size="small"
                                  fullWidth
                                  sx={{
                                    width: '200px',
                                    '& .MuiInputBase-root': { height: '25px' },
                                    '.css-1mj2sml-MuiInputBase-root-MuiOutlinedInput-root.Mui-error .MuiOutlinedInput-notchedOutline': {
                                      borderColor: '#1e82e9',
                                    }
                                  }}
                                />
                              )}
                            />
                          </Box>
                        </>
                      )}
                      {/* {!task?.dev_due_date&&<Box
                        component={MobileDatePicker}
                        // label="Actual development period"
                        value={devDueDate}
                        minDate={moment()}
                        onChange={(date) => setDevDueDate(date)}
                        onAccept={(acceptedDate) => {handleUpdateDevDueDate(acceptedDate)}}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            size="small"
                            fullWidth
                            sx={{
                              width: '200px',
                              '& .MuiInputBase-root': { height: '25px' },
                              '.css-1mj2sml-MuiInputBase-root-MuiOutlinedInput-root.Mui-error .MuiOutlinedInput-notchedOutline': {
                                borderColor: '#1e82e9',
                            }
                            }}
                          />
                        )}
                      /> }                                         */}
                      <Typography gutterBottom variant="subtitle2">
                        {/* color={'text.secondary'}  */}
                        Created By :
                        {task?.created_by}
                      </Typography>

                      <Typography gutterBottom variant="subtitle2">
                        {/* color={'text.secondary'}  */}
                        Module :
                        {task?.module_name}
                      </Typography>

                      <Typography gutterBottom variant="subtitle2">
                        {/* color={'text.secondary'}  */}
                        Uploaded Files :
                        {files?.length > 0 ? (
                          files.map((file, index) => (
                            <div key={file.ID} style={{ marginBottom: "10px" }}>

                              <Button
                                size='small'
                                variant="contained"
                                color="primary"
                                // onClick={() => viewFile(file.file_url)}
                                onClick={() => {
                                  setPdfLoading(true);
                                  setSelectedPDF(file.file_url);
                                  setOpenPDFModal(true);
                                }}
                              >
                                View File {index + 1}
                              </Button>
                            </div>
                          ))
                        ) : (
                          <Typography variant="body2" color="textSecondary">
                            No files available
                          </Typography>
                        )}
                      </Typography>
                    </Stack>
                  </Stack>
                </Stack>
                <Stack
                  sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    flexDirection: 'row',
                  }}
                >
                  <Stack>
                    <Typography variant="subtitle2">Support Agents</Typography>
                    <AvatarGroup >
                      {taskMembers?.slice(0, 4).map((row) => (
                        <Tooltip key={row.ID} title={row.username || 'No Name Provided'}>
                          <Avatar src={row.profile_pic} alt={row.username} />
                        </Tooltip>
                      ))}
                      {taskMembers?.length > 4 && (
                        <Tooltip title="Show all">
                          <Avatar
                            onClick={handleOpens}
                            style={{ cursor: 'pointer', backgroundColor: '#c8e6c9' }}
                          >
                            +{taskMembers.length - 4}
                          </Avatar>
                        </Tooltip>
                      )}
                    </AvatarGroup>

                    {/* Modal to show all avatars */}
                    <Modal open={opens} handleClose={handleCloses}>
                      <Box
                      >
                        <Typography variant="h6" gutterBottom>
                          All Support Agents
                        </Typography>
                        <Scrollbar sx={{ height: '350px' }}>
                          <Stack spacing={2}>
                            {taskMembers?.map((row) => (
                              <Stack key={row.ID} direction="row" spacing={2} alignItems="center">
                                <Avatar src={row.profile_pic} alt={row.username} />
                                <Typography variant="body1">{row.username || 'No Name Provided'}</Typography>
                              </Stack>
                            ))}
                          </Stack>
                        </Scrollbar>
                        <Button
                          variant="contained"
                          onClick={handleCloses}
                          sx={{ mt: 2, display: 'block', ml: 'auto' }}
                        >
                          Close
                        </Button>
                      </Box>
                    </Modal>
                  </Stack>




                </Stack>
                {!empty(message) && (
                  <>
                    <Typography variant="subtitle1">Ticket Messages</Typography>
                    <Card sx={{ height: '400px', paddingTop: '20px', paddingBottom: '20px' }}>
                      <Scrollbar>
                        <Stack spacing={3} sx={{ p: 3 }}>
                          <Stack spacing={1.5}>
                            {message?.map((comment) => (
                              <Stack key={comment.ID} direction="row" spacing={2}>
                                <Paper
                                  sx={{
                                    p: 1.5,
                                    flexGrow: 1,
                                    bgcolor: 'background.neutral',
                                  }}
                                >
                                  <Stack
                                    direction={{ xs: 'column', sm: 'row' }}
                                    alignItems={{ sm: 'center' }}
                                    justifyContent="space-between"
                                    sx={{ mb: 0.5 }}
                                  >
                                    <Box sx={{ display: 'flex', flexDirection: 'row' }}>
                                      <Avatar sx={{ width: 23, height: 23 }} alt={comment.name} src={comment.profile_pic} />
                                      <Typography variant="caption">
                                        {comment.name}
                                      </Typography>
                                    </Box>
                                    <Typography
                                      variant="caption"
                                      sx={{ color: 'text.disabled' }}
                                    >
                                      {getAgoString(comment.timestamp)}
                                    </Typography>
                                  </Stack>
                                  <Stack direction={{ xs: 'column', sm: 'row' }}
                                    alignItems={{ sm: 'center' }}
                                    justifyContent="space-between"
                                    sx={{ position: 'relative', mb: 0.5 }}>
                                    <Typography
                                      variant="body2"
                                      sx={{ color: 'text.secondary', pr: 4 }}
                                    >
                                      <ActivityComponent activity={comment.message} />
                                    </Typography>
                                    {userData.user_id === comment.userid &&
                                      <IconButton
                                        onClick={() => deleteMessage(comment.ID)} // Pass the message ID
                                        sx={{
                                          position: 'absolute',
                                          top: 0,
                                          right: 0,
                                          color: 'error.main',
                                        }}
                                      >
                                        <Icon icon={trash2Outline} width={20} height={20} />
                                      </IconButton>}
                                  </Stack>
                                </Paper>

                              </Stack>
                            ))}
                          </Stack>

                        </Stack>
                      </Scrollbar>
                    </Card>
                  </>
                )}
                <Stack sx={{ mb: 2 }}>
                  <LabelStyle>Add Message to Ticket</LabelStyle>
                  <QuillEditor
                    simple
                    id="ticket-description"
                    value={postMessage}
                    onChange={(val) => { setPostMessage(val) }}
                  />
                </Stack>
                <Box
                  sx={{
                    mt: 3,
                    display: 'flex',
                    justifyContent: 'flex-end',
                    gap: 1,
                  }}
                >
                  <LoadingButton
                    type="submit"
                    onClick={sendPostMessage}
                    variant="contained"
                    loading={isPosting}
                    disabled={isPosting}
                  >
                    Post Message
                  </LoadingButton>
                </Box>
              </Card>

            </Stack>
          </Grid>
        </Grid>

        <Modal open={openPop} handleClose={HandleClose} modalTitle={'Add Support Agents'}>
          <Grid
            container
            spacing={2}
            direction={{ xs: 'column', md: 'row' }}
          >
            <Grid item xs={12} md={10} xl={10}>
              <Box
                sx={{
                  width: '100%',
                  p: 2,
                  bgcolor: 'background.neutral',
                }}
              >
                <Stack
                  sx={{
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'space-between',
                  }}
                >
                </Stack>
                <Stack sx={{ display: 'flex', flexDirection: 'row' }}>
                  <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                    Select Agents
                  </Typography>
                </Stack>

                <Autocomplete
                  fullWidth
                  multiple
                  id="combo-box-demo"
                  options={members || []}
                  onChange={(event, newVal) => handleMember(newVal)}
                  getOptionLabel={(state) =>
                    state?.first_name + ' ' + state?.last_name
                  }
                  // sx={{ width: 400 }}
                  renderInput={(params) => <TextField {...params} />}
                />
                <Box
                  sx={{
                    mt: 3,
                    display: 'flex',
                    justifyContent: 'flex-end',
                    gap: 1,
                  }}
                >
                  <LoadingButton
                    type="submit"
                    variant="contained"
                    onClick={() => {
                      setIsPosting(true);
                      addMemberstoTicket()
                    }}
                    loading={isPosting}
                    disabled={isPosting}
                  >
                    Save
                  </LoadingButton>
                  <Button
                    variant="outlined"
                    type="submit"
                    onClick={() => {
                      setOpenPop(false)
                    }}
                  >
                    Cancel
                  </Button>
                </Box>
              </Box>
            </Grid>
          </Grid>
        </Modal>
        {/* </Popover> */}
        <ConfirmationPopup
          message={`You want to delete this ${task?.name} task`}
          open={delPopup}
          handleClose={() => {
            setDelPopup(!delPopup), setIsOpen(!open)
          }}
          handleClick={() => DeleteTicket()}
        />
        <ConfirmationPopup
          message={`You want to change the status to " ${valueTemp.value} " `}
          open={statusChangeOpen}
          handleClose={() => setStatusChangeOpen(false)}
          handleClick={() => {
            setValue({ id: valueTemp.id, value: valueTemp.value })
            handleUpdateStatus(valueTemp.id)
            setStatusChangeOpen(false)
          }}
        />
        <DialogAnimate open={openPDFModal} onClose={() => setOpenPDFModal(false)}>
        <Card className={classes.dialogContent}>
          <div style={{ width: '90%', display: 'flex', justifyContent: 'flex-end', marginBottom: '15px', marginLeft: '25px' }}>
            <Button
              variant="outlined"
              color="primary"
              onClick={() => window.open(selectedPDF, '_blank')}
              disabled={!selectedPDF}
              startIcon={<Icon icon={filePdfIcon} width={20} height={20} />}
              sx={{
                fontSize: '14px'
              }}
            >
              View PDF
            </Button>
          </div>
          {pdfLoading && (
            <Skeleton variant="rectangular" width="100%" height={500} sx={{ justifyContent: 'center' }} />
          )}

          {selectedPDF?.toLowerCase().includes('.pdf') ? (
            <iframe
              src={selectedPDF}
              title="Selected PDF"
              width="100%"
              height="500px"
              frameBorder="0"
              style={{ display: pdfLoading ? 'none' : 'block' }}
              onLoad={() => setPdfLoading(false)}
            />
          ) : selectedPDF?.toLowerCase().match(/\.(jpeg|jpg|png|gif|bmp|webp)/) ? (
            <Box
              component={'div'}
              style={{
                width: '100%',
                height: '500px',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                borderRadius: 8,
                overflow: 'hidden',
                display: pdfLoading ? 'none' : 'block'
              }}
            >
              <img
                src={selectedPDF}
                alt="Preview"
                style={{
                  width: '100%',
                  height: '100%',
                  objectFit: 'cover',
                  borderRadius: 8,
                }}
                onLoad={() => setPdfLoading(false)}
              />

            </Box>
          ) : (
            <Box p={2}>
              <Typography variant="body2">
                Preview not available. <a href={selectedPDF} target="_blank" rel="noopener noreferrer">Click to download</a>.
              </Typography>
            </Box>
          )}
        </Card>
      </DialogAnimate>
    </Container>
    
  )
}
